import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { AppProvider } from './context/AppContext'
import './i18n'
import './index.css'

/**
 * `staleTime` alto a proposito: las respuestas del motor son deterministas
 * para los mismos datos, asi que volver a pedir WHEN al cambiar de pestana es
 * tirar CPU. Se invalida a mano desde la cache cuando corre el ETL.
 *
 * `refetchOnWindowFocus: false` por lo mismo: en una demo, refocusar la
 * ventana no debe provocar tres peticiones al motor.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('falta #root en index.html')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppProvider>
    </QueryClientProvider>
  </StrictMode>,
)
